import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import {useUserService} from "../../services/user-service";
import Loading from "../../components/loading";
import {useParams} from "react-router-dom";
import Attachment from "../../components/files/attachment";
import AddEditUserModal from "./add-edit-user-modal";
import AddressCell from "../../components/address-cell";
import ContactCell from "../../components/contact-cell";
import {UserTypes} from "../../utils/constants";
import {Accordion} from "react-bootstrap";
import BankAccountCell from "../../components/bank-account-cell";
import UserRepresentativeCell from "../../components/user-representative-cell";


export default function UserDetail () {
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const params = useParams();
  const [model, setModel] = useState();
  const userService = useUserService();
  const addEditModal = useRef();

  useEffect(()=>{
    let id = params.id;
    if (id){
      userService.getDetail(id)
        .then((user)=>{
          setModel(user);
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať detail.");
        })
    }
  }, [params.id]);

  const onAddEditAction = (item=null, e=null)=>{
    addEditModal.current.openModal(item);
  };

  const onAddEditCallbackAction = (item=null)=>{
    setModel(item);
  };

  const onAttachmentDelete = (removedItem)=>{
    setModel((model)=>{
      return {...model, attachments: [...HelperService.removeItemFromList(model.attachments, removedItem)]}
    });
  }

  return (
    <>
      <AddEditUserModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>{model ? model.name : 'Detail používateľa'}</PageTitle>
          <button disabled={!model} className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(model, e)}><span className="mdi mdi-book-edit-outline"></span> Upraviť</button>

          <div className="row">

            {!model && <Loading className="m-2" />}

            {model && <>

              <div className="col-sm-12 col-md-8">
                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h3>Základné info</h3>
                        <span className='mb-1 badge bg-primary'>{HelperService.getObjByKey(Object.values(UserTypes), 'val', model.type)?.title}</span><br />
                        <span>Meno:</span> <strong>{model.name}</strong><br />
                        <span>Login:</span> <strong>{model.login}</strong><br />
                        {model.birth_number && <><span>Rodné číslo:</span> <strong>{model.birth_number}</strong><br /></>}
                        {model.birth_at && <><span>Dátum narodenia:</span> <strong>{HelperService.formatDate(model.birth_at)}</strong><br /></>}
                        <span>Štátna príslušnosť:</span> <strong>{model.nationality}</strong><br />
                        <span>Jazyk:</span> <strong>{model.locale}</strong><br />
                        <span>Časová zóna:</span> <strong>{model.timezone}</strong><br />
                        <span>Rola:</span> <strong>{model.global_roles && model.global_roles.length ? model.global_roles[0].title : ''}</strong><br />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h3>Firma</h3>
                        <span>Obchodné meno:</span> <strong>{model.company}</strong><br />
                        <span>IČO:</span> <strong>{model.company_number}</strong><br />
                        <span>DIČ:</span> <strong>{model.tax_id}</strong><br />
                        <span>IČDPH:</span> <strong>{model.dph_id}</strong><br />
                        <span>Registrácia:</span> <strong>{model.company_registration}</strong><br />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-body">
                        <h3>Adresy</h3>
                        {!model.addresses?.length>0 && <p className='text-muted'>Zatiaľ žiadne adresy.</p>}
                        {model.addresses?.length>0 && <div className="row">{model.addresses?.map((address)=>{
                          return (<div key={address.id} className="col-md-6">
                            <AddressCell className="col-sm-12"
                                         address={address} />
                          </div>)
                        })}
                        </div>}
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-body">
                        <h3>Kontakty</h3>
                        {!model.contacts?.length>0 && <p className='text-muted'>Zatiaľ žiadne kontakty.</p>}
                        {model.contacts?.length>0 && <div className="row">{model.contacts?.map((contact)=>{
                          return (<div key={contact.id} className="col-md-6">
                            <ContactCell className="col-sm-12"
                                         contact={contact} />
                          </div>)
                        })}
                        </div>}
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-body">
                        <h3>Bankové účty</h3>
                        {!model?.bank_accounts?.length>0 && <p className='text-muted'>Zatiaľ žiadne bankové účty.</p>}
                        {model?.bank_accounts?.length>0 && <div className="row">{model.bank_accounts?.map((bankAccount)=>{
                          return (<div key={bankAccount.id} className="col-md-6">
                            <BankAccountCell className="col-sm-12"
                                             bankAccount={bankAccount} />
                          </div>)
                        })}
                        </div>}
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-body">
                        <h3>Delegáti</h3>
                        {!model?.user_representatives?.length>0 && <p className='text-muted'>Zatiaľ žiadny delegáti.</p>}
                        {model?.user_representatives?.length>0 && <div className="row">{model.user_representatives?.map((userRepresentative)=>{
                          return (<div key={userRepresentative.id} className="col-md-12">
                            <UserRepresentativeCell className="col-sm-12"
                                                    userRepresentative={userRepresentative}
                            />
                          </div>)
                        })}
                        </div>}
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-body">
                        <h3>Verzie</h3>
                        {model.activities && model.activities.length>0 && <Accordion defaultActiveKey="0">
                          {model.activities.map((version, index)=>{
                            return <Accordion.Item key={version.id} eventKey={index} className="custom-accordion">
                              <Accordion.Header>{HelperService.formatDateTime(version.created_at)} | {version.description}</Accordion.Header>
                              <Accordion.Body>
                                <div className='row'>
                                  <div className='col-sm-12 col-md-6'>
                                    <h5>Staré údaje</h5>
                                    {HelperService.objectPrettyPrint(version.properties.old)}
                                  </div>
                                  <div className='col-sm-12 col-md-6'>
                                    <h5>Nové údaje</h5>
                                    {HelperService.objectPrettyPrint(version.properties.attributes)}
                                  </div>
                                </div>

                              </Accordion.Body>
                            </Accordion.Item>
                          })}
                        </Accordion>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="col-12 col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h3>Dokumenty</h3>
                      {model.attachments && model.attachments.length>0 && <div className="row">
                        {model.attachments.map((att)=>{
                          return <div key={att.id} className="col-12"><Attachment attachment={att} onDelSuccess={(att)=>onAttachmentDelete(att)} /></div>;
                        })}
                      </div>}
                    </div>
                  </div>
                </div>
              </div>

            </>}

          </div>
        </div>
      </Section>
    </>
  );
}

UserDetail.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

UserDetail.getSEO = function getSEO() {
  return {
    title: "Detail používateľa",
  }
}
